import React, { useState, useRef, useEffect } from 'react';
import { ContentHeader } from '@components';
import { Button } from 'react-bootstrap';
import GoogleMapReact from 'google-map-react';
import { Form } from 'react-bootstrap';
import { DateTimePicker, TimePicker } from 'react-tempusdominus-bootstrap';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import SignatureCanvas from 'react-signature-canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fetchDropdownData, submitFormData } from '../../services/apifp';
import { SearchBox, SelectedBox } from '../fastprint/SearchBox'; // ใช้ไฟล์ SearchBox.tsx ในโฟลเดอร์เดียวกัน

// ให้ dropdown ของ Google Places อยู่เหนือแผนที่
const autocompleteStyles = `
  .pac-container {
    z-index: 200000 !important;
  }
  #map-container .map-search-container {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 200001;
    width: min(600px, 100%);
  }
  #map-container .selected-box-container {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 200001;
    width: 320px;
  }
`;

export default function Registershop() {
  const _tk = localStorage.getItem('gatekeeper_token');
  const [formData, setFormData] = useState({
    name: '',
    taxId: '',
    installationPoint: '',
    contactPerson: '',
    phone: '',
    email: '',
    contactPerson2: '',
    addressByIdCard: '',
    address: '',
    gpsLocation: '',
    rewardType: '',
    shopType: '',
    installDate: new Date().toISOString().split('T')[0],
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1) - 86400000)
      .toISOString()
      .split('T')[0],
    rentalFee: '',
    machinesNumber: '',
    msd: '',
    bank: '',
    bankAccount: '',
    workDays: '',
    workHourStart: null,
    workHourEnd: null,
  });
  const dispatch = useDispatch();
  const [dropdownData, setDropdownData] = useState<any>({
    BANK: { DATA: [] },
    PAYMENT: { DATA: [] },
    SHOP_TYPE: { DATA: [] },
    MSD: { DATA: [] },
    SHOP_WORKING_DAY: { DATA: [] },
  });

  interface DropdownOption {
    value: string;
    label: string;
  }
  interface DropdownData {
    BANK: { DATA: DropdownOption[] };
    PAYMENT: { DATA: DropdownOption[] };
    SHOP_TYPE: { DATA: DropdownOption[] };
    MSD: { DATA: DropdownOption[] };
    SHOP_WORKING_DAY: { DATA: DropdownOption[] };
  }

  useEffect(() => {
    const loadDropdownData = async () => {
      try {
        const data = await fetchDropdownData();
        setDropdownData({
          BANK: data.BANK || { DATA: [] },
          PAYMENT: data.PAYMENT || { DATA: [] },
          SHOP_TYPE: data.SHOP_TYPE || { DATA: [] },
          MSD: data.MSD || { DATA: [] },
          SHOP_WORKING_DAY: data.SHOP_WORKING_DAY || { DATA: [] },
        });
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
        dispatch(logoutUser());
        window.location.href = '/login';
      }
    };
    loadDropdownData();
  }, [dispatch]);

  const [errorFields, setErrorFields] = useState<string[]>([]);
  const isFormValid = () => {
    const requiredFields = ["name", "rewardType", "msd", "shopType", "gpsLocation", "bank", "workDays"];
    const invalidFields = requiredFields.filter((field) => !formData[field]);
    if (!formData.machinesNumber || parseInt(formData.machinesNumber || '0', 10) <= 0) {
      invalidFields.push("machinesNumber");
    }
    setErrorFields(invalidFields);
    return invalidFields.length === 0;
  };

  const [showMap, setShowMap] = useState(false);
  const [showMarker, setShowMarker] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapContainerRef = useRef(null);

  useEffect(() => {
    const checkFullscreen = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", checkFullscreen);
    return () => document.removeEventListener("fullscreenchange", checkFullscreen);
  }, []);

  const handleMapClick = ({ lat, lng }: { lat: number; lng: number }) => {
    setShowMarker(true);
    setMyposition({ center: { lat, lng }, zoom: myposition.zoom });
    setFormData((prevState) => ({
      ...prevState,
      gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}`,
    }));
  };

  const toggleFullscreen = () => {
    const mapContainer = document.getElementById("map-container");
    if (!document.fullscreenElement) {
      mapContainer?.requestFullscreen().catch((err) => console.error("Fullscreen error:", err));
    } else {
      document.exitFullscreen();
    }
  };
  const handleConfirmLocation = () => {
    if (formData.gpsLocation) {
      toast.success(`ตำแหน่งที่เลือก: ${formData.gpsLocation}`);
      setShowMap(false);
    } else {
      toast.error('กรุณาเลือกตำแหน่งบนแผนที่');
    }
  };

  function MarkerIcon({ lat, lng }: { lat: number; lng: number }) {
    return (
      <div
        style={{
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          color: 'red',
          fontSize: '24px',
        }}
      >
        <FontAwesomeIcon icon={fas.faMapMarkerAlt} />
      </div>
    );
  }

  const [myposition, setMyposition] = useState({
    center: { lat: 13.545550016333902, lng: 100.96180662698616 },
    zoom: 17,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setMyposition((prevState) => ({
            ...prevState,
            center: { lat: position.coords.latitude, lng: position.coords.longitude },
          }));
        },
        (error) => {
          console.error("ไม่สามารถดึงตำแหน่งได้: ", error);
          alert("ไม่สามารถดึงตำแหน่งได้ ใช้ตำแหน่งเริ่มต้นแทน");
        }
      );
    } else {
      alert("เบราว์เซอร์ของคุณไม่รองรับการดึงตำแหน่งปัจจุบัน");
    }
  }, []);

  // map refs / instances used for SearchBox
  const mapRef = useRef<any>(null);
  const mapApi = useRef<any>(null);
  const apiReady = useRef(false);
  const [mapInstance, setMapInstance] = useState<any>(null);
  const [mapsApiInstance, setMapsApiInstance] = useState<any>(null);

  const handleApiLoaded = (map: any, maps: any) => {
    if (map && maps) {
      mapRef.current = map;
      mapApi.current = maps;
      setMapInstance(map);
      setMapsApiInstance(maps);
      apiReady.current = true;

      const mapOptions = {
        gestureHandling: 'greedy',
        zoom: 17,
        styles: [{ featureType: 'all', elementType: 'all', stylers: [{ visibility: 'on' }] }],
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: maps.ControlPosition.BOTTOM_CENTER,
          mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE],
        },
      };
      map.setOptions(mapOptions);
    }
  };

  const handleStartDateChange = (e: any) => {
    if (e.date) {
      const newStartDate = e.date.toDate().toISOString().split('T')[0];
      const newEndDate = new Date(newStartDate);
      newEndDate.setFullYear(newEndDate.getFullYear() + 1);
      newEndDate.setDate(newEndDate.getDate() - 1);
      setFormData((prevState) => ({
        ...prevState,
        startDate: newStartDate,
        endDate: newEndDate.toISOString().split('T')[0],
      }));
    }
  };

  const handleEndDateChange = (e: any) => {
    if (e.date) {
      const newEndDate = e.date.toDate().toISOString().split('T')[0];
      setFormData((prevState) => ({ ...prevState, endDate: newEndDate }));
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [signature, setsignature] = useState('');
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const handleShowSignatureModal = () => setShowSignatureModal(true);
  const handleCloseSignatureModal = () => setShowSignatureModal(false);
  const signRef = useRef<SignatureCanvas | null>(null);
  const handleGenerateSignature = () => {
    if (signRef.current) {
      const signatureDataUrl = signRef.current.getTrimmedCanvas().toDataURL('image/png');
      setsignature(signatureDataUrl);
      handleCloseSignatureModal();
    }
  };
  const handleClearSignature = () => {
    if (signRef.current) {
      signRef.current.clear();
      setsignature('');
    }
  };
  const [signature2, setSignature2] = useState('');
  const [showSignature2Modal, setShowSignature2Modal] = useState(false);
  const handleShowSignature2Modal = () => setShowSignature2Modal(true);
  const handleCloseSignature2Modal = () => setShowSignature2Modal(false);
  const signRef2 = useRef<SignatureCanvas | null>(null);
  const handleGenerateSignature2 = () => {
    if (signRef2.current) {
      const signatureDataUrl = signRef2.current.getTrimmedCanvas().toDataURL('image/png');
      setSignature2(signatureDataUrl);
      handleCloseSignature2Modal();
    }
  };
  const handleClearSignature2 = () => {
    if (signRef2.current) {
      signRef2.current.clear();
      setSignature2('');
    }
  };

  const navigate = useNavigate();
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!isFormValid()) {
      toast.error('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }
    const dataToSubmit = { ...formData, signature, signature2: signature2 || '' };
    try {
      const response = await submitFormData(dataToSubmit);
      if (response.status === false) {
        toast.error(response.message || 'เกิดข้อผิดพลาดในการบันทึก');
      } else {
        toast.success('บันทึกข้อมูลสำเร็จ!');
        navigate('/fp-me?shop_id=' + response.shopId);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }
  };

  // SelectedBox state + handler
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const handleSelectedValueChange = (value: string, amount: string) => {
    setSelectedItems((prev) => prev.map((it) => (it.value === value ? { ...it, amount } : it)));
  };

  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: autocompleteStyles }} />
      <ContentHeader title="FastPrint Team" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Card className="mt-0">
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    {/* ชื่อนิติบุคคล/ชื่อบุคคล */}
                    <div className="row">
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชื่อนิติบุคคล/ชื่อบุคคล</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="ชื่อนิติบุคคล/ชื่อบุคคล"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          style={{
                            borderColor: errorFields.includes("name") ? "red" : "",
                          }}
                        />
                      </Form.Group>

                      {/* เลขผู้เสียภาษี/เลขบัตรประชาชน */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลขผู้เสียภาษี/เลขบัตรประชาชน</Form.Label>
                        <Form.Control
                          type="text"
                          name="taxId"
                          placeholder="เลขผู้เสียภาษี/เลขบัตรประชาชน"
                          value={formData.taxId}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* ชื่อจุดติดตั้ง/ชื่อร้านค้า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชื่อจุดติดตั้ง/ชื่อร้านค้า</Form.Label>
                        <Form.Control
                          type="text"
                          name="installationPoint"
                          placeholder="ชื่อจุดติดตั้ง/ชื่อร้านค้า"
                          value={formData.installationPoint}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* ผู้กระทำการแทน */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ผู้กระทำการแทน</Form.Label>
                        <Form.Control
                          type="text"
                          name="contactPerson"
                          placeholder="ผู้กระทำการแทน"
                          value={formData.contactPerson}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      {/* เบอร์โทรศัพท์ */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เบอร์โทรศัพท์</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          placeholder="เบอร์โทรศัพท์"
                          value={formData.phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* อีเมล์ */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>อีเมล์</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="อีเมล์"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* บุคคลติดต่อ2 */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ผู้ติดต่อประสานงาน(ชื่อและเบอร์โทร)</Form.Label>
                        <Form.Control
                          type="text"
                          name="contactPerson2"
                          placeholder="ผู้ติดต่อประสานงาน"
                          value={formData.contactPerson2}
                          onChange={handleChange}
                        // required
                        />
                      </Form.Group>
                      {/* วันทำการ */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันทำการ</Form.Label>
                        <Form.Control
                          as="select"
                          name="workDays"
                          value={formData.workDays}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("workDays") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกวันทำการ --</option>
                          {dropdownData.SHOP_WORKING_DAY.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                      {/* เวลาเปิดเครื่อง */}
                      <Form.Group className="mb-3 col-md-2">
                        <Form.Label>เวลาเปิดเครื่อง</Form.Label>
                        <TimePicker
                          date={formData.workHourStart} // ✅ ใช้ค่าเวลาเดิม
                          format="HH:mm" // ✅ แสดงแค่ "ชั่วโมง:นาที"
                          onChange={(e) => {
                            if (e?.date) {
                              const newWorkHourStart = e.date.format("HH:mm"); // ✅ แปลงเป็นรูปแบบเวลา HH:mm
                              setFormData((prevState) => ({
                                ...prevState,
                                workHourStart: newWorkHourStart, // ✅ อัปเดตเฉพาะเวลา
                              }));
                            }
                          }}
                        />
                      </Form.Group>
                      {/* เวลาปิดเครื่อง */}
                      <Form.Group className="mb-3 col-md-2">
                        <Form.Label>เวลาปิดเครื่อง</Form.Label>
                        <TimePicker
                          date={formData.workHourEnd} // ✅ ใช้ค่าเวลาเดิม
                          format="HH:mm" // ✅ แสดงแค่ "ชั่วโมง:นาที"
                          onChange={(e) => {
                            if (e?.date) {
                              const newWorkHourEnd = e.date.format("HH:mm"); // ✅ แปลงเป็นรูปแบบเวลา HH:mm
                              setFormData((prevState) => ({
                                ...prevState,
                                workHourEnd: newWorkHourEnd, // ✅ อัปเดตเฉพาะเวลา
                              }));
                            }
                          }}
                        />
                      </Form.Group>


                    </div>
                    {/* ที่อยู่ตามบัตรประชาชน/ภพ20 */}
                    <Form.Group className="mb-3">
                      <Form.Label>ที่อยู่ตามบัตรประชาชน/ภ.พ.20</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="addressByIdCard"
                        placeholder="กรอกที่อยู่ตามบัตรประชาชน/ภ.พ.20"
                        value={formData.addressByIdCard}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    {/* GPS Location */}
                    <div className="row">
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>GPS Location</Form.Label>
                        <div className="input-group">
                          {/* Input Field */}
                          <Form.Control
                            type="text"
                            name="gpsLocation"
                            placeholder="กรุณากดเลือกตำแหน่งบนแผนที่"
                            value={formData.gpsLocation}
                            readOnly
                            style={{
                              borderColor: errorFields.includes("gpsLocation") ? "red" : "",
                            }}
                          />
                          {/* Button with Icon */}
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              setShowMap(true);
                              setShowMarker(true); // ⛔ รีเซ็ต Marker ทุกครั้งที่เปิดใหม่
                            }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >
                            <FontAwesomeIcon icon={fas.faLocationDot} />
                          </button>
                        </div>
                      </Form.Group>

                      {/* Modal สำหรับเลือกตำแหน่งแผนที่ */}
                      {/* ✅ Modal สำหรับเลือกตำแหน่งแผนที่ */}
                      <Modal show={showMap} onHide={() => setShowMap(false)} size="lg" centered>
                        <Modal.Header closeButton>
                          <Modal.Title>เลือกตำแหน่งบนแผนที่</Modal.Title>
                        </Modal.Header>
                        <Modal.Title>
                        <div className="map-search-container">
                          <SearchBox
                            map={mapInstance}
                            mapApi={mapsApiInstance}
                            addplace={(place: any) => {
                              if (!place || !place.geometry) return;
                              const lat = place.geometry.location.lat();
                              const lng = place.geometry.location.lng();
                              if (mapRef.current?.panTo) mapRef.current.panTo({ lat, lng });
                              if (mapRef.current?.setZoom) mapRef.current.setZoom(17);
                              setMyposition((prev) => ({ ...prev, center: { lat, lng }, zoom: 17 }));
                              setShowMarker(true);
                              setFormData((prev) => ({ ...prev, gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}` }));

                              // เพิ่มรายการตัวอย่างให้ SelectedBox
                              const label = place.name || place.formatted_address || 'ตำแหน่ง';
                              setSelectedItems((prev) => [
                                ...prev,
                                {
                                  label,
                                  value: place.place_id || Date.now().toString(),
                                  amount: '',
                                  unit: '',
                                  selected: true,
                                },
                              ]);
                            }}
                          />
                        </div>

                        {/* SelectedBox */}
                        <div className="selected-box-container">
                          <SelectedBox selected={selectedItems} isDisabled={false} onValueChange={handleSelectedValueChange} />
                        </div>
                        </Modal.Title>
                        <Modal.Body>
                          <div
                            ref={mapContainerRef}
                            id="map-container"
                            style={{ height: isFullscreen ? "100vh" : "70vh", width: "100%", position: "relative" }}
                          >
                            {/* SearchBox */}


                            <GoogleMapReact
                              bootstrapURLKeys={{
                                key: "AIzaSyB88aLnfSb_Fe1_q8483R6_jcZjKznODWo",
                                libraries: ["places", "geometry"],
                              }}
                              center={myposition.center}
                              defaultZoom={myposition.zoom}
                              yesIWantToUseGoogleMapApiInternals
                              onGoogleApiLoaded={({ map, maps }) => {
                                handleApiLoaded(map, maps);
                              }}
                              onClick={handleMapClick}
                            >
                              {showMarker && <MarkerIcon lat={myposition.center.lat} lng={myposition.center.lng} />}
                            </GoogleMapReact>

                            <button
                              onClick={toggleFullscreen}
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "white",
                                border: "1px solid #ccc",
                                padding: "8px",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              {isFullscreen ? "ออกจาก Fullscreen" : "Fullscreen"}
                            </button>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" onClick={handleConfirmLocation}>
                            ยืนยันตำแหน่ง
                          </Button>
                          <Button variant="secondary" onClick={() => setShowMap(false)}>
                            ปิด
                          </Button>
                        </Modal.Footer>
                      </Modal>


                      {/* ชนิดผลตอบแทนจ่าย */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชนิดผลตอบแทนจ่าย</Form.Label>
                        <Form.Control
                          as="select"
                          name="rewardType"
                          value={formData.rewardType}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("rewardType") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกชนิดผลตอบแทนจ่าย --</option>
                          {dropdownData.PAYMENT.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      {/* ชนิดร้านค้า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชนิดร้านค้า</Form.Label>
                        <Form.Control
                          as="select"
                          name="shopType"
                          value={formData.shopType}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("shopType") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกชนิดร้านค้า --</option>
                          {dropdownData.SHOP_TYPE.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                    {/* ที่อยู่จุดติดตั้ง */}
                    <Form.Group className="mb-3 md-4">
                      <Form.Label>ที่อยู่จุดติดตั้ง</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        placeholder="ที่อยู่จุดติดตั้ง"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <div className="row">
                      {/* ประมาณการวันที่ติดตั้ง */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ประมาณการวันที่ติดตั้ง</Form.Label>
                        <DateTimePicker
                          date={formData.installDate} // ใช้ค่า installDate จาก formData
                          format="YYYY-MM-DD"
                          onChange={(e) => {
                            const newInstallDate = e.date.toISOString().split('T')[0]; // แปลงวันที่ใหม่เป็น YYYY-MM-DD
                            setFormData((prevState) => ({
                              ...prevState,
                              installDate: newInstallDate,
                            }));
                          }}
                        />
                      </Form.Group>

                      {/* ค่าเช่า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ค่าเช่า</Form.Label>
                        <Form.Control
                          type="number"
                          name="rentalFee"
                          placeholder="ค่าเช่า"
                          value={formData.rentalFee}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* เลือก MSD */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลือก MSD</Form.Label>
                        <Form.Control
                          as="select"
                          name="msd"
                          value={formData.msd}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("msd") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือก MSD --</option>
                          {dropdownData.MSD.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </div>

                    <div className="row">
                      {/* จำนวนเครื่อง */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>จำนวนเครื่อง</Form.Label>
                        <Form.Control
                          type="number"
                          name="machinesNumber"
                          placeholder="จำนวนเครื่อง"
                          value={formData.machinesNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          // required
                          style={{
                            borderColor: errorFields.includes("machinesNumber") ? "red" : "",
                          }}
                        />
                      </Form.Group>

                      {/* วันที่เริ่มต้นสัญญา */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันที่เริ่มต้นสัญญา</Form.Label>
                        <DateTimePicker
                          date={formData.startDate}
                          format="YYYY-MM-DD"
                          onChange={handleStartDateChange}
                        />
                      </Form.Group>

                      {/* วันที่สิ้นสุดสัญญา */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันที่สิ้นสุดสัญญา</Form.Label>
                        <DateTimePicker
                          date={formData.endDate}
                          format="YYYY-MM-DD"
                          onChange={handleEndDateChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* เลือกธนาคาร */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลือกธนาคาร</Form.Label>
                        <Form.Control
                          as="select"
                          name="bank"
                          value={formData.bank}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("bank") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกธนาคาร --</option>
                          {dropdownData.BANK.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      {/* เลขที่บัญชีธนาคาร */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลขที่บัญชีธนาคาร</Form.Label>
                        <Form.Control
                          type="text"
                          name="bankAccount"
                          placeholder="เลขที่บัญชีธนาคาร"
                          value={formData.bankAccount}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row p-0">
                      {/* การรับรู้และลายเซ็น */}
                      <div className="col-md-6 col-12 m-0">
                        <Card className="m-0 col-md-12">

                          <Card.Header>ลงนามผู้กระทำการแทน</Card.Header>
                          <Card.Body>
                            <div
                              id="signature-area"
                              className="mt-3 position-relative"
                              style={{
                                width: '100%',
                                height: '150px',
                                border: '1px solid gray',
                                backgroundColor: 'white',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {/* ปุ่ม "ลงนาม" */}
                              <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleShowSignatureModal}
                                style={{
                                  zIndex: 1, // ทำให้ปุ่มแสดงอยู่ข้างบนเสมอ

                                }}
                              >
                                <i className="fa fa-pencil"></i> ลงนาม
                              </button>

                              {/* แสดงภาพลายเซ็นเมื่อมีการเซ็นแล้ว */}
                              {signature && (
                                <img
                                  src={signature} // แสดงลายเซ็นคนที่สอง
                                  alt="ลายเซ็นผู้กระทำการแทน"
                                  style={{
                                    maxWidth: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    maxHeight: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    display: signature ? 'block' : 'none', // ซ่อนหากยังไม่มีลายเซ็น
                                  }}
                                />
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>

                      <div className="col-md-6 col-12 m-0">
                        {/* การรับรู้และลายเซ็น */}
                        <Card className="m-0 col-md-12">
                          <Card.Header>ลงนามพยาน/ผู้ติดต่อประสานงาน</Card.Header>
                          <Card.Body>

                            <div
                              id="signature-area"
                              className="mt-3 position-relative"
                              style={{
                                width: '100%',
                                height: '150px',
                                border: '1px solid gray',
                                backgroundColor: 'white',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {/* ปุ่ม "ลงนาม" */}
                              <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleShowSignature2Modal}
                                style={{
                                  zIndex: 1, // ทำให้ปุ่มแสดงอยู่ข้างบนเสมอ

                                }}
                              >
                                <i className="fa fa-pencil"></i> ลงนาม
                              </button>

                              {/* แสดงภาพลายเซ็นเมื่อมีการเซ็นแล้ว */}
                              {signature2 && (
                                <img
                                  src={signature2} // แสดงลายเซ็นคนที่สอง
                                  alt="ลายเซ็นพยาน/ผู้ติดต่อประสานงาน"
                                  style={{
                                    maxWidth: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    maxHeight: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    display: signature2 ? 'block' : 'none', // ซ่อนหากยังไม่มีลายเซ็น
                                  }}
                                />
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>



                    </div>
                    <Button
                      className="mt-3"
                      type="submit"
                      disabled={!signature}
                      variant={!signature ? 'secondary' : 'primary'}
                    >
                      {!signature ? 'บันทึกข้อมูล' : 'บันทึกข้อมูล'}
                    </Button>

                  </Form>
                  {/* {_tk} */}

                  {/* {response && (
                    <div className="mt-4">
                      <h5>Response:</h5>
                      <pre>{JSON.stringify(response, null, 2)}</pre>
                    </div>
                  )} */}
                </Card.Body>
              </Card>

              {/* Modal ลายเซ็น */}
              <Modal show={showSignatureModal} onHide={handleCloseSignatureModal}>
                <Modal.Header closeButton>
                  <Modal.Title>ลงนามผู้กระทำการแทน</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div
                    className="col-12"
                    style={{
                      border: "2px solid black",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 500,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signRef}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="success" onClick={handleGenerateSignature}>
                    ใช้ลายเซ็นนี้
                  </Button>
                  <Button variant="warning" onClick={handleClearSignature}>
                    เซ็นใหม่
                  </Button>
                </Modal.Footer>
              </Modal>
              {/* Modal ลายเซ็น */}
              <Modal show={showSignature2Modal} onHide={handleCloseSignature2Modal}>
                <Modal.Header closeButton>
                  <Modal.Title>ลงนามพยาน/บุคคลติดต่อคนที่ 2</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div
                    className="col-12"
                    style={{
                      border: "2px solid black",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 500,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signRef2}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="success" onClick={handleGenerateSignature2}>
                    ใช้ลายเซ็นนี้
                  </Button>
                  <Button variant="warning" onClick={handleClearSignature2}>
                    เซ็นใหม่
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
  rel="stylesheet"
/>